import React, { Component } from "react";
import { Icon } from "@iconify/react";

import reactIcon from "@iconify/icons-logos/react";
import expressjsIcon from "@iconify/icons-logos/express";
import nextjsIcon from "@iconify/icons-logos/nextjs";

import nodejsIcon from "@iconify/icons-logos/nodejs";

class About extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = "images/" + this.props.sharedBasicInfo.image;
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
    }

    return (
      <section id="about">
        <div className="col-md-12">
          <h1 style={{ color: "black" }}>
            <span>{sectionName}</span>
          </h1>
          <div className="row center mx-auto mb-5">
            <div className="col-md-4 mb-5 center">
              <div className="polaroid">
                <span style={{ cursor: "auto" }}>
                  <img
                    width="100%"
                    height="auto"
                    src={profilepic}
                    alt="Harsh"
                  />
                  <Icon
                    icon={nodejsIcon}
                    title="Nodejs"
                    style={{ fontSize: "300%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={expressjsIcon}
                    style={{ fontSize: "300%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={nextjsIcon}
                    style={{ fontSize: "300%", margin: "9% 5% 0 5%" }}
                  />
                  <Icon
                    icon={reactIcon}
                    style={{ fontSize: "300%", margin: "9% 5% 0 5%" }}
                  />
                </span>
              </div>
            </div>

            <div className="col-md-8 center">
              <div className="col-md-10">
                <div className="card">
                  <div className="card-header">
                    <span
                      className="iconify"
                      data-icon="emojione:red-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:yellow-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:green-circle"
                      data-inline="false"
                    ></span>
                  </div>
                  <div
                    className="card-body font-trebuchet text-justify ml-3 mr-3"
                    style={{
                      height: "auto",
                      fontSize: "132%",
                      lineHeight: "200%",
                    }}
                  >
                    <br />
                    <span className="wave">{hello} :) </span>
                    <br />
                    <br />
                    <p style={{ textAlign: "left" }}>
                      👋 Hi, I’m Harsh, I am a seasoned Senior Full Stack Web
                      Developer with a rich background spanning over six years.
                      My journey in the industry involves crafting cutting-edge
                      web applications and products tailored for diverse clients
                      and industries.
                      <br />
                      🎓 <b>Educational Background:</b> <br />
                      Hold a Bachelor of Engineering degree in Information
                      Technology, complemented by a Diploma of Education in
                      Information Technology.
                      <br />
                      💼 <b>Current Role Currently:</b> <br />
                      contributing remotely as a full-stack Web developer,
                      playing a pivotal role in various projects. Engage in
                      daily communication with clients, discussing project
                      intricacies, providing solutions on a daily basis, and
                      ensuring seamless project progress. 🔧 Technical Expertise
                      I specialize in the MERN stack, proficiently leveraging
                      HTML/CSS, Javascript, NodeJS, ExpressJS, MongoDB, and
                      Nextjs. My skills extend to robust programming, effective
                      debugging, and implementing model-view-controller
                      architecture. <br />
                      💡 <strong>Passion & Mission:</strong> <br />
                      My passion lies in creating dynamic, user-friendly, and
                      scalable web solutions that align with the needs and
                      expectations of end-users and stakeholders. Collaborating
                      with talented developers, designers, and managers fuels my
                      enthusiasm. I'm committed to continuous learning,
                      exploring new technologies, and adopting best practices.{" "}
                      <br />
                      🌐 <strong>
                        Project Collaborations Throughout:
                      </strong>{" "}
                      <br /> my career, I've collaborated on impactful projects
                      with notable clients and individuals. The journey involves
                      leveraging my skills to contribute to the success and
                      growth of various initiatives. Each project has been an
                      opportunity to learn, innovate, and deliver solutions that
                      exceed expectations. <br />
                      🌟 <strong>Vision:</strong> <br /> Striving to enhance my
                      coding prowess, my ultimate goal is to make impactful
                      contributions to the success and growth of projects and
                      individuals I collaborate with. <br />
                      💞️ Let's connect and explore the exciting possibilities
                      in the world of web development!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
